document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e)=> {
    const button = e.target.closest('.indiv-product') || e.target.closest('.search-product');
    if(!button) {
      return;
    }

    const isSearchPage = window.location.pathname === '/search' || button.classList.contains('search-product');

    e.preventDefault();

    if(button.hasAttribute('data-add-to-box') || button.closest('[data-add-to-box]')) return;
    const productHandle = button.dataset.customProductHandle;
      fetch(`/products/${productHandle}?view=popup`).then(response => response.text()).then(data => {
        const parser = new DOMParser();
        const html = parser.parseFromString(data, 'text/html');
        const productPopup = html.getElementById('product_popup_overlay');

        document.getElementById('main-body') && document.getElementById('main-body').insertAdjacentElement('afterbegin', productPopup);
        const popupEl = document.getElementById('product_popup_overlay');
        new QuantityControls(this.theme, popupEl);
        !document.querySelector('html').classList.contains('scroll-locked') && document.querySelector('html').classList.add('scroll-locked');

        document.getElementById('product_popup').addEventListener('click',(e) => e.stopPropagation());
        document.getElementById('product_popup').querySelectorAll('.close_popup').forEach(closeBtn => closeBtn.addEventListener('click',(e) => {
          document.querySelector('.product_popup_overlay').remove();
          document.querySelector('html').classList.contains('scroll-locked') && document.querySelector('html').classList.remove('scroll-locked')
        }));

        document.getElementById('product_popup_overlay') && document.getElementById('product_popup_overlay').addEventListener('click', (e) => {
          if (!button.closest('#product_popup') || button.closest('.close_popup')) {
            document.querySelector('.product_popup_overlay').remove();
            document.querySelector('html').classList.contains('scroll-locked') && document.querySelector('html').classList.remove('scroll-locked')
          }
        });

        if(isSearchPage) {
          document.querySelector('.product_popup_overlay').style.top = 0;
        }
      })
    })
  })
